import React from 'react';
import styled from '@emotion/styled';
import { StyledParkingProductCardSubtitle } from './StyledParkingProductCard';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';

interface IParkingProductSpotsRemainingProps {
	spotsAmount: number;
}
const ParkingProductSpotsRemaining = ({
	spotsAmount,
}: IParkingProductSpotsRemainingProps) => {
	const { t } = useTranslation();
	return (
		<StyledParkingProductSpotsRemaining data-testid="spots-remaining-banner">
			<span data-testid="spots-remaining-amount">{spotsAmount}</span>
			<span>
				{spotsAmount === 1
					? ` ${t(`web_parking_product_spot_text`)} ${t(
							`web_parking_product_spot_remaining_text`,
					  )}`
					: ` ${t(`web_parking_product_spots_text`)} ${t(
							`web_parking_product_spots_remaining_text`,
					  )}`}
			</span>
		</StyledParkingProductSpotsRemaining>
	);
};

export default ParkingProductSpotsRemaining;

const StyledParkingProductSpotsRemaining = styled(
	StyledParkingProductCardSubtitle,
)`
	background: #f3d67b;
`;
